module.exports = __webpack_public_path__ + "img/simcard.21638b89.png";